import { render, staticRenderFns } from "./pgNotification.vue?vue&type=template&id=1f2c3588&scoped=true&"
import script from "./pgNotification.vue?vue&type=script&lang=js&"
export * from "./pgNotification.vue?vue&type=script&lang=js&"
import style0 from "./pgNotification.vue?vue&type=style&index=0&id=1f2c3588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c3588",
  null
  
)

export default component.exports